/* eslint-disable no-unused-vars */
import Vue from 'vue'
import uuidv4 from 'uuid/v4'
import firebase from 'firebase/compat/app'
import worldNameFormat from '../../shared_methods/formattingMixin'
const state = {
	all: {},
	handheld:{trip:1},
	allIds: [],
	allMsgIds: []
}

const generateEmptyWorld = function(worldNameFormattedForDb){
	return {
		worldName:worldNameFormattedForDb,
		complete_achievements:[],
		complete_missions:[],
		worldBadges:[],
		pageVisited:false,
		classAssessmentTaken:false,
		suitabilityAssessmentTaken:false,
		videosWatched:[],
		employmentVideoWatched:false,
		visitedSidebarElementNames:[],
		careersLearned:[],
		answers:[],
		createdAtIso: dateIsoString()
		,createdAt:  Date.now()
		
	}

}
const seedFirst = function(worldName,worldArray,studentId,studentEmail){

	let statusRef = firebase.firestore().collection('status')
	let worldNameFormatted= worldNameFormat.methods.worldNameToDbNameFormat(worldName);

	var studentDoc = statusRef.doc(studentId)
		// projectsRef = collection(db, "status");


		//var cityRef = db.collection('cities').doc('BJ');
	
		console.log("sid"+studentId)
		console.log("warry"+worldArray)
		let worldsStatus={}	
		let worldNames=[];	
		
			console.log(worldArray)
			worldArray.map((x)=> {
			console.log(x.file_name_url);
			let worldNameFormatted= worldNameFormat.methods.worldNameToDbNameFormat(x.file_name_url);

			worldsStatus[worldNameFormatted] = generateEmptyWorld(worldNameFormatted);
			worldNames.push(worldNameFormatted);
			}
			)
			console.log(worldsStatus)
			
			var setWithMerge1 = statusRef.doc(studentId).set({
				
				badges:[],
				studentEmail:studentEmail,
				createdAtIso:dateIsoString(),
				createdAt:  Date.now(),
				firstSlingshotLogin:dateIsoString(),
				studentId:studentId,
				totalPoints: 0,
				totalAchievements: 0,
				totalMissions:0,
				worldsVisited:[],
				worldsStatus:worldsStatus,
				worldList:worldNames,

			}, { merge: true });

		
		

		console.log(worldsStatus)



		
	
		console.log("Documents should be added now!");	  
	
	console.log("seedMany")
}
const seedExisting= function(studentId,worldName){
	let statusRef = firebase.firestore().collection('status')
	let worldNameFormattedForDb= worldNameFormat.methods.worldNameToDbNameFormat(worldName);

	var studentDoc = statusRef.doc(studentId)
	console.log(" doc exists")
	
		console.warn(worldNameFormattedForDb);
		console.warn("wn");
			const newWorld= generateEmptyWorld(worldNameFormattedForDb)

			statusRef.doc(studentId).update({
				[`worldsStatus.${worldNameFormattedForDb}`]: newWorld

			});

	
	console.log("seedOne")
}
const dateIsoString = function(){
	var now = new Date();
	var isoString = now.toISOString();
	return isoString
}
const mutations = {
	SET_CONVERSATION (state, { conversation }) {
		const data = conversation.data()
		state.all = {...state.all, [conversation.id]: { users: data.users, created: data.created, messages: [] }} 

		state.allIds.push(conversation.id)
	},
	SET_HANDHELD (state, { dbState }) {
		console.log("sthh");
		console.log(dbState);
		state.handheld = dbState

		//state.allIds.push(conversation.id)
	},
	ADD_MESSAGE (state, { conversationId, message }) {
		if (!state.allMsgIds.includes(message.id)) {
			state.all[conversationId].messages.push(message)
			state.allMsgIds.push(message.id)
		}
	},
}
const getters = {
getHandheld(state) {
      return state.handheld
    }
  }
const actions = {
	sendMessage ({ commit, rootState }, { text, created, sender, conversationId }) {
		const convoRef = rootState.db.collection('conversations').doc(conversationId)

		convoRef.update({
			messages: [...state.all[conversationId].messages, { id: uuidv4(), created, sender, text }]
		})
		.then(res => console.log('Message sent.'))
		.catch(err => console.log('Error', err))
	},
	addElementInteraction ({ commit, rootState }, {docId, elementName, worldName }) {
       console.log(docId +" " +elementName +" "+ worldName )
		
		let statusRef = firebase.firestore().collection('status')
		let worldNameFormattedForDb= worldNameFormat.methods.worldNameToDbNameFormat(worldName);
		statusRef.doc(docId).update({
			[`worldsStatus.${worldNameFormattedForDb}.visitedSidebarElementName`]: firebase.firestore.FieldValue.arrayUnion(elementName)

		})
		.then(res => console.log('Message sent.'))
		.catch(err => console.log('Error', err))
		
	},
	addBadge ({ commit, rootState }, {docId, badgeSrc, badgeName }) {
			console.log(docId +" " +badgeSrc +" "+ badgeName ) 
			let statusRef = firebase.firestore().collection('status')
			statusRef.doc(docId).update({
			badges: firebase.firestore.FieldValue.arrayUnion({badgeName:badgeName,badgeSrc:badgeSrc})
		}).then(res => console.log('badge sent.'))
		.catch(err => console.log('Error', err))
	},
	addCareerLearned ({ commit, rootState }, {docId, worldName, careerId}) {
		console.log(docId +" "+ worldName +" "+ careerId)
		
		let statusRef = firebase.firestore().collection('status')
		let worldNameFormattedForDb= worldNameFormat.methods.worldNameToDbNameFormat(worldName);
		statusRef.doc(docId).update({
			[`worldsStatus.${worldNameFormattedForDb}.careersLearned`]: firebase.firestore.FieldValue.arrayUnion(careerId)
	}).then(res => console.log('career added sent.'))
	.catch(err => console.log('Error', err))
},
	async seed ({ commit,rootState},{worldArray,studentId,individual=true,worldName="",studentEmail=""}) {
		let statusRef = firebase.firestore().collection('status')
		let worldNameFormattedForDb= worldNameFormat.methods.worldNameToDbNameFormat(worldName);
			console.warn("$$"+individual)
		var studentDoc = statusRef.doc(studentId)

		studentDoc.get().then((doc) => {
			if (doc.exists) {
				if (individual === true){
					seedExisting(studentId,worldName);
				}
				}
				else{
					console.log(worldName)
					console.log(individual)
					console.warn("&&"+individual)
					
					
						seedFirst(worldNameFormattedForDb,worldArray,studentId,studentEmail);
					}
				})
	
		
	
	
	
	

			

	
		
	},
	addProperty ({ commit,rootState},{docId,worldName,property,propertyValue}) {

		console.log("AP")
		let statusRef = firebase.firestore().collection('status')

		
		
			//console.log("ind"+individual)
			//console.log("sid"+studentId)
			//console.log("warry"+worldArray)

	
		
		
					statusRef.doc(docId).update({
						[`worldsStatus.${worldName}.${property}`]: propertyValue
					});
	
			
	


	
			
		
			console.log("property updated");	  
	},
	addInteraction({ commit,rootState},{docId,worldName,property,propertyValue}) {

		console.log("AP")
		let statusRef = firebase.firestore().collection('status')

		
		
			//console.log("ind"+individual)
			//console.log("sid"+studentId)
			//console.log("warry"+worldArray)

	
		
		
					statusRef.doc(docId).update({
						[`worldsStatus.${worldName}.${property}`]: propertyValue
					});
	
			
	


	
			
		
			console.log("property updated");	  
	},
	setPointsAndMissionAcc({ commit,rootState},{docId,MISSION_OR_ACC_NAME,MISSION_OR_ACC,points,currentWorld,secret=false}) {
					let statusRef = firebase.firestore().collection('status')
					let worldNameFormattedForDb= worldNameFormat.methods.worldNameToDbNameFormat(currentWorld);

					console.warn("macc")
						console.log(MISSION_OR_ACC_NAME)
					var statusDocRef= statusRef.doc(docId)
					if (MISSION_OR_ACC ==="mission"){

						statusRef.doc(docId).update({
							totalPoints: firebase.firestore.FieldValue.increment(points) ,
							[`worldsStatus.${worldNameFormattedForDb}.points`]: firebase.firestore.FieldValue.increment(points),
							[`worldsStatus.${worldNameFormattedForDb}.complete_missions`]: firebase.firestore.FieldValue.arrayUnion(MISSION_OR_ACC_NAME),
							totalMissions: firebase.firestore.FieldValue.increment(1)
						});


					}
					else if (MISSION_OR_ACC ==="achieve") {
						if (secret === true) {
							statusRef.doc(docId).update({

								totalPoints: firebase.firestore.FieldValue.increment(points) ,
								totalAchievements: firebase.firestore.FieldValue.increment(1) ,
							
							});

						}
						else{
						statusRef.doc(docId).update({
							totalPoints: firebase.firestore.FieldValue.increment(points) ,
							totalAchievements: firebase.firestore.FieldValue.increment(1) ,
							[`worldsStatus.${worldNameFormattedForDb}.points`]: firebase.firestore.FieldValue.increment(points),
							[`worldsStatus.${worldNameFormattedForDb}.complete_achievements`]: firebase.firestore.FieldValue.arrayUnion(MISSION_OR_ACC_NAME)
						});
						}

					}
			
	

	},
	setPageVisit ({ commit,rootState},{docId,worldName}) {
		let statusRef = firebase.firestore().collection('status')

		
		
			//console.log("ind"+individual)
			//console.log("sid"+studentId)
			//console.log("warry"+worldArray)

			statusRef.doc(docId).update({
				[`worldsStatus.${worldName}.pageVisited`]: true

			});
			console.warn(worldName);
			statusRef.doc(docId).update({
				timestamp: firebase.firestore.FieldValue.serverTimestamp(),

				visitedWorlds: firebase.firestore.FieldValue.arrayUnion(worldName)
			});
		


	
			
		
			console.log("property updated");	  
	},
	submitAnswers ({ commit,rootState},{docId,formDataObj}) {
		let statusRef = firebase.firestore().collection('status')
		console.log(formDataObj)
		
			//console.log("ind"+individual)
			//console.log("sid"+studentId)
			//console.log("warry"+worldArray)
			statusRef.doc(docId).update({
				timestamp: firebase.firestore.FieldValue.serverTimestamp(),

				answers: firebase.firestore.FieldValue.arrayUnion({...formDataObj, createdAtIso: dateIsoString(),createdAt:  Date.now()})
			});
		


	
			
		
			console.log("property updated");	  
	},
	async get ({ commit, rootState }) {
		let convoRef = rootState.db.collection('conversations')
		let convos = await convoRef.get()

		convos.forEach(conversation => commit('SET_CONVERSATION', { conversation }))
	},
	updateState ({ commit, rootState }, { text, created, sender, conversationId }) {

    var sfDocRef = rootState.db.collection("cities").doc("SF");

	rootState.db.runTransaction((transaction) => {
		return transaction.get(sfDocRef).then((sfDoc) => {
			if (!sfDoc.exists) {
				throw "Document does not exist!";
			}
	
			var newPopulation = sfDoc.data().population + 1;
			if (newPopulation <= 1000000) {
				transaction.update(sfDocRef, { population: newPopulation });
				return newPopulation;
			} else {
				return Promise.reject("Sorry! Population is too big.");
			}
		});
	}).then((newPopulation) => {
		console.log("Population increased to ", newPopulation);
	}).catch((err) => {
		// This will be an "population is too big" error.
		console.error(err);
	});
	}
	

}

export default { namespaced: true, state, mutations, actions,getters }